import { Box } from '@mui/material';
import React from 'react';
import { useSessionStorage } from 'react-use';
import { Waypoint } from 'react-waypoint';

import SkeletonLoader from '@components/SkeletonLoader';

import { useGetS3AssetRecordLazyQuery } from 'generated/file.generated';

export default function PrivateImage({
  alt = '',
  cssStyle,
  height,
  width,
  patient_id,
  record_id,
  is_sharing,
}: {
  alt?: string;
  cssStyle?: React.CSSProperties;
  height: number;
  width: number;
  patient_id: string;
  record_id: string;
  is_sharing?: boolean;
}) {
  const [token] = useSessionStorage('share_token');
  const [fetch, { data, loading }] = useGetS3AssetRecordLazyQuery({
    ...(is_sharing && {
      context: {
        headers: {
          authorization: token,
        },
      },
    }),
  });

  const handleEnter = async () => {
    await fetch({
      variables: {
        input: {
          patient_id,
          record_id,
        },
      },
    });
  };

  const src = data?.getS3AssetRecord.presignedGetUrl;
  const [isBlurred, setIsBlurred] = React.useState(true);
  return (
    <Waypoint onEnter={handleEnter}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
        }}
      >
        <SkeletonLoader
          height={height}
          width="100%"
          loading={loading && !src}
          sx={{ ...cssStyle }}
          variant={cssStyle?.borderRadius ? 'circular' : 'rectangular'}
        >
          <div onClick={() => setIsBlurred((prev) => !prev)}>
            <img
              alt={alt}
              src={src ?? ''}
              width={width}
              height={height}
              style={{
                height,
                width,
                filter: isBlurred ? 'blur(20px)' : 'none',
                transition: 'filter 0.3s ease, opacity 0.3s ease',
                ...cssStyle,
              }}
            />
            {isBlurred && (
              <span
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: '#fff',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.6)',
                  fontWeight: 'bold',
                  fontSize: '3rm',
                  textAlign: 'center',
                }}
              >
                Click to view image
              </span>
            )}
          </div>
        </SkeletonLoader>
      </Box>
    </Waypoint>
  );
}
